import { viewportProjection } from '../viewportProjection.js';
import ECGViewport from './ECGViewport.js';
class ECGViewportLegacyAdapter extends ECGViewport {
    async setEcg(imageId) {
        await this.setDisplaySets({ displaySetId: imageId });
    }
    setChannelVisibility(index, visible) {
        const waveform = this.getWaveformData();
        const dataId = this.getFirstBinding()?.data.id;
        if (!waveform || !dataId) {
            return;
        }
        const current = this.getDisplaySetPresentation(dataId) || {};
        const nextVisibleChannels = new Set(current.visibleChannels || waveform.channels.map((_channel, i) => i));
        if (visible) {
            nextVisibleChannels.add(index);
        }
        else {
            nextVisibleChannels.delete(index);
        }
        this.setDisplaySetPresentation(dataId, {
            visibleChannels: Array.from(nextVisibleChannels).sort((a, b) => a - b),
        });
    }
    setProperties(props) {
        const dataId = this.getFirstBinding()?.data.id;
        if (!dataId) {
            return;
        }
        this.setDisplaySetPresentation(dataId, {
            visibleChannels: props.visibleChannels,
        });
    }
    getProperties() {
        const dataId = this.getFirstBinding()?.data.id;
        return {
            visibleChannels: dataId
                ? this.getDisplaySetPresentation(dataId)?.visibleChannels
                : undefined,
        };
    }
    resetProperties() {
        const waveform = this.getWaveformData();
        const dataId = this.getFirstBinding()?.data.id;
        if (!waveform || !dataId) {
            return;
        }
        this.setDisplaySetPresentation(dataId, {
            visibleChannels: waveform.channels.map((_channel, index) => index),
        });
    }
    getViewPresentation(selector) {
        return viewportProjection.getPresentation(this, {
            selector,
        });
    }
    setViewPresentation(viewPres) {
        if (!viewPres) {
            return;
        }
        const nextViewState = viewportProjection.withPresentation(this, viewPres);
        if (nextViewState) {
            this.setViewState(nextViewState);
        }
    }
    resetCamera() {
        return this.resetViewState();
    }
}
export default ECGViewportLegacyAdapter;
